import { Page, PageTitle } from "@/components/page"
import { Send, Plus } from "lucide-react"
import { DataTableSupabase } from "@/components/datatable/supadatatable"
import { DataTable } from "@/components/datatable/datatable"
import { useTeamStore } from "@/lib/hooks/useTeam"
import { Button } from "@/components/ui/button"
import { useNavigate } from "react-router-dom"
import { useCallback } from "react"
import { usePermissions } from "@/lib/hooks/usePermissions"

const typeOptions = {
  0: "Hourly",
  1: "Daily",
  2: "Monthly",
}

export const campaigns = {
  title: "Campaigns",
  description: "Manage your WhatsApp template campaigns and their schedules.",
  route: "/campaigns",
  url: "/campaigns",
  group: "communications",

  icon: Send,
  component,
  resource: "jobs",
  action: "read",
} satisfies PageConfig

const columns: Columns<Table<"jobs">> = {
  title: { header: "Title", size: 500 },
  team: { header: "Team", size: 200, cell: ({ row }) => row.original.team?.["name"] },
  type: { header: "Type", size: 200, cell: ({ row }) => typeOptions[row.original.type] || "Unknown" },
  created_at: { header: "Created", cell: DataTable.cellRender.date, size: 166 },
}

function component() {

  const { selectedTeam } = useTeamStore()
  const navigate = useNavigate()
  const { canCreate } = usePermissions()
  const filter = useCallback(q => q.eq("team", selectedTeam?.id).contains("parameters", { kind: "whatsapp_template" }), [selectedTeam])

  return <Page>
    <div className="h-full grid grid-rows-[auto_1fr] gap-4">
      <div className="flex">
        <PageTitle />
        <div className="grow"></div>
        {canCreate("jobs") && <div>
          <Button className="rounded-lg" onClick={() => navigate('/campaign/new')} ><Plus className="h-4 w-4" />Create Campaign</Button>
        </div>}
      </div>
      <DataTableSupabase
        table="jobs"
        columns={columns}
        showSelection
        onRowClick={"/campaign"}
        sort={["created_at", "desc"]}
        filter={filter}
        select={`
        *,
        team (
          name
        )
      `}
        enableServerSideFiltering={true}
        searchableColumns={["title"]}
      />
    </div>
  </Page>

}
